module.exports = __webpack_public_path__ + "files/a3de5b3fa99880f206badaf857d72744.png";